module.exports = "/static/assets/43a0f0ae2927a6a173ae5e2aa2478bca.gif";